import React, { useState } from "react";
import "./ModalMedTabs.css";
import DeviceList from "../devices/deviceList.js";
import { useAuth } from "../login/authProvider.js";
import AdminPage from "../admin/adminpage.js"; 
import MyPages from "../mypage/mypages.js";
import { CompanyScopeProvider } from "../context/CompanyScopeContext";


import logo2 from "../assets/logo2.png";

const ModalMedTabs = () => {
  const [activeTab, setActiveTab] = useState("tab2");
  const [devices, setDevices] = useState([]); 
  const { user, logout } = useAuth(); 

  const renderContent = () => {
    switch (activeTab) {
       case "tab2":
        return <MyPages />;
      case "enheter":
        return <DeviceList setDevices={setDevices} />;
      
      case "admin":
        return <AdminPage />; 
      case "tab4":
        return <div>Du har loggats ut.</div>;
      default:
        return null;
    }
  };

  return (
    <div className="modal-background">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title">Community Enhetsportal</h1>
          <img src={logo2} alt="Logo" className="modal-logo" />
        </div>
        <div className="tab-bar">
        

      
          <button
            className={activeTab === "tab2" ? "tab active" : "tab"}
            onClick={() => setActiveTab("tab2")}
          >
            Mina sidor
          </button>
           <button
            className={activeTab === "enheter" ? "tab active" : "tab"}
            onClick={() => setActiveTab("enheter")}
          >
            Enheter
          </button>

      
          {user?.isAdmin && (
            <button
              className={activeTab === "admin" ? "tab active" : "tab"}
              onClick={() => setActiveTab("admin")}
            >
              Admin
            </button>
          )}

          <button
            className={activeTab === "tab4" ? "tab active" : "tab"}
            onClick={() => {
              setActiveTab("tab4");
              logout();
            }}
          >
            Logga ut
          </button>
        </div>
    <CompanyScopeProvider>
      <div className="tab-content">{renderContent()}</div>
  </CompanyScopeProvider>
      </div>
    </div>
  );
};

export default ModalMedTabs;
